import { render, staticRenderFns } from "./InteractionQuestion.vue?vue&type=template&id=42cd038c&scoped=true"
import script from "./InteractionQuestion.vue?vue&type=script&lang=js"
export * from "./InteractionQuestion.vue?vue&type=script&lang=js"
import style0 from "./InteractionQuestion.vue?vue&type=style&index=0&id=42cd038c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42cd038c",
  null
  
)

export default component.exports